'use strict';
import { SpatialVisionState } from '@states/SpatialVision.js';
import { UIDiv, UISelect, UIText } from '@ui';

const SERVICE_TIERS = [
  { value: 'cloud', label: 'O-HIVE VLM CLOUD' },
  { value: 'pro', label: 'O-HIVE VLM PRO' },
];

class SpatialVisionProviderSelector extends UIDiv {
  constructor({ compact = false } = {}) {
    super();
    this.compact = compact;
    this.setClass(
      compact
        ? 'flex items-center gap-2'
        : 'flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2',
    );
    this.#build();
  }

  #build() {
    const state = SpatialVisionState.spatialVision;
    this.select = new UISelect();
    this.select.setClass(
      this.compact
        ? 'h-8 rounded-full border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none focus:ring-2 focus:ring-blue-500'
        : 'rounded-md border border-gray-300 bg-white px-2 py-1.5 text-xs outline-none focus:ring-2 focus:ring-blue-500',
    );

    SERVICE_TIERS.forEach(option => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value;
      optionElement.textContent = option.label;
      this.select.dom.appendChild(optionElement);
    });

    this.select.setValue(state.selectedServiceTier || 'cloud');
    this.select.dom.addEventListener('change', event => {
      event.stopPropagation();
      SpatialVisionState.selectServiceTier(this.select.getValue());
    });

    if (!this.compact) {
      this.add(
        new UIText('Service').setClass('text-xs font-medium text-gray-600'),
        this.select,
      );
      return;
    }

    this.add(
      new UIText('Service').setClass('text-sm font-medium text-slate-600'),
      this.select,
    );
  }

  syncValue() {
    this.select?.setValue(
      SpatialVisionState.spatialVision.selectedServiceTier || 'cloud',
    );
  }
}

export { SpatialVisionProviderSelector };
